import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconZoomInSvg } from "./IconZoomInSvg.mjs";
const IconZoomIn = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconZoomInSvg, ...svgProps }) });
export {
  IconZoomIn
};
